import { Factory } from 'rosie';

Factory.define('AgentAssistanceConfig').attr('disableHeroAI', false);
